import {
    Heading,
    Stack,
    ThemeFontSizeVariable,
    ThemeSpaceVariable,
} from "@caspeco/casper-ui-library";
import { useTranslation } from "react-i18next";
import EditGuests from "./edit-guests";
import { useStepTracking } from "logger/use-step-tracking";
import { TrackingStepName } from "logger/user-tracking";

interface EditGuestsViewProps {
    guests: number | null;
    setGuests: (guests: number | null) => void;
    availableGuestSizes: number[];
}

const EditGuestsView = ({ guests, setGuests, availableGuestSizes }: EditGuestsViewProps) => {
    const { t } = useTranslation();

    useStepTracking({
        stepName: TrackingStepName.EditBookingGuests,
    });

    return (
        <Stack spacing={ThemeSpaceVariable.Medium}>
            <Heading as="h3" fontSize={ThemeFontSizeVariable.XLarge}>
                {t("editBooking.chooseNewGuests")}
            </Heading>
            <EditGuests
                setGuests={setGuests}
                guests={guests}
                availableGuestSizes={availableGuestSizes}
            />
        </Stack>
    );
};

export default EditGuestsView;
